var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"widget-item messages-board",style:(_vm.style),attrs:{"id":_vm.widget.object.wid}},[_c('MessagesBoardViewer',{attrs:{"widgetData":_vm.widget.object,"appId":_vm.widget.object.wid},on:{"saveData":_vm.saveAppData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }